import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";

const UserAvatar = ({ name }) => {
  return (
    <div className="site__user dropdown-toggle">
      <span className="site__user-avatar">
        <FontAwesomeIcon
          icon={faUserCircle}
          className="fas fa-lg fa-user-circle me-1"
          aria-hidden="true"
        />
      </span>
      <span className="site__user-name">{name}</span>
    </div>
  );
};

UserAvatar.propTypes = {
  name: PropTypes.string.isRequired
};

export default UserAvatar;
